import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { GraphicalDataSourceSubsetBase } from "abweb/dto/generated/gds/GraphicalDataSourceSubsetBase";
export class GraphicalDataSourceSubset extends GraphicalDataSourceSubsetBase {
  constructor() {
    super();
    _defineProperty(this, "_rootNode", null);
  }
  initGraphicalDataSourceSubset(edges, nodes) {
    super.initGraphicalDataSourceSubset(edges, nodes);
    for (let node of nodes) {
      this.setUpNodes(node, null);
    }
  }
  setUpNodes(node, parentNode) {
    node._parentNode = parentNode;
    for (let childNode of node.nodes) {
      this.setUpNodes(childNode, node);
    }
  }
  get rootNode() {
    return this._rootNode;
  }
  set rootNode(value) {
    if (value === this._rootNode) {
      return;
    }
    this._rootNode = value;
    this.onRootNodeChanged();
  }
  onRootNodeChanged() {
    for (let node of this.nodes) {
      node._parentNode = this.rootNode;
    }
  }
}
//# sourceMappingURL=GraphicalDataSourceSubset.js.map
